import React, {useEffect, useState} from 'react';
import {HeroTitle, StorySection} from "../components";
import backgroundImageHome from "../assets/images/background/bg.jpg";
import usePageTitle from "../hooks/usePageTitle";
import {HeroShimmer, StorySectionShimmer} from "../components/shimmer";
const Story = () => {
    usePageTitle('Histoire')
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Simuler un temps de chargement de 2 secondes
        const timer = setTimeout(() => {
            setLoading(false);
        }, 2000);

        return () => clearTimeout(timer);
    }, []);

    if (loading) {
        return (
            <div className="flex flex-col">
                <HeroShimmer/>
                <StorySectionShimmer/>
            </div>
        );
    }

    return (
        <div className="flex flex-col">
            <HeroTitle
                title="L’Histoire d’Ambalavao : Un patrimoine riche et authentique"
                description="Depuis ses origines comme carrefour commercial jusqu’à sa renommée pour son artisanat, Ambalavao incarne un héritage culturel et naturel unique au cœur de la région Haute Matsiatra. Découvrez ses traditions, son marché emblématique, et son rôle dans la préservation de la nature."
                backgroundImage={backgroundImageHome}
            />
            {/* Story Section */}
            <section className="w-full">
                <StorySection/>
            </section>
        </div>
    );
};

export default Story;